import { render } from "./tabelaPrecoView.vue?vue&type=template&id=0f217166"
import script from "./tabelaPrecoView.vue?vue&type=script&lang=js"
export * from "./tabelaPrecoView.vue?vue&type=script&lang=js"

import "./tabelaPrecoView.vue?vue&type=style&index=0&id=0f217166&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__